import { useState } from 'react';
import { ChromePicker } from 'react-color';
import styles from './FlowchartToolbar.module.css';

interface FlowchartEdgeToolbarProps {
  edge: any;
  onUpdate: (updates: any) => void;
  onClose: () => void;
}

export default function FlowchartEdgeToolbar({ edge, onUpdate, onClose }: FlowchartEdgeToolbarProps) {
  const [showColorPicker, setShowColorPicker] = useState(false);

  const handleLabelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onUpdate({
      label: e.target.value
    });
  };

  const handleColorChange = (color: any) => {
    const newColor = color.hex;
    onUpdate({
      style: {
        ...edge.style,
        stroke: newColor
      }
    });
  };

  const handleWidthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newWidth = parseInt(e.target.value, 10);
    onUpdate({
      style: {
        ...edge.style,
        strokeWidth: newWidth
      }
    });
  };

  const handleDashChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onUpdate({
      style: {
        ...edge.style,
        strokeDasharray: e.target.value
      }
    });
  };



  return (
    <div className={styles.toolbarFloating}>
      <div className={styles.toolbarHeader}>
        <h3 className={styles.toolbarTitle}>Edge Properties</h3>
        <button
          onClick={onClose}
          className={styles.toolbarClose}
        >
          ×
        </button>
      </div>

      <div className={styles.toolbarGroup}>
        <label className={styles.toolbarLabel}>Label</label>
        <input
          type="text"
          value={edge.label || ''}
          onChange={handleLabelChange}
          placeholder="Enter edge label..."
          className={styles.toolbarInput}
        />
      </div>

      <div className={styles.toolbarGroup}>
        <label className={styles.toolbarLabel}>Color</label>
        <div className={styles.colorPickerWrapper}>
          <button
            onClick={() => setShowColorPicker(!showColorPicker)}
            className={styles.colorButton}
          >
            <div
              className={styles.colorSwatch}
              style={{ backgroundColor: edge.style?.stroke || '#000000' }}
            />
            {edge.style?.stroke || '#000000'}
          </button>
          {showColorPicker && (
            <div className={styles.colorPickerPopup}>
              <ChromePicker
                color={edge.style?.stroke || '#000000'}
                onChange={handleColorChange}
              />
            </div>
          )}
        </div>
      </div>

      <div className={styles.toolbarGroup}>
        <label className={styles.toolbarLabel}>
          Width: {edge.style?.strokeWidth || 2}px
        </label>
        <input
          type="range"
          min="1"
          max="10"
          value={edge.style?.strokeWidth || 2}
          onChange={handleWidthChange}
          className={styles.toolbarRange}
        />
      </div>

      <div className={styles.toolbarGroup}>
        <label className={styles.toolbarLabel}>Style</label>
        <select
          value={edge.style?.strokeDasharray || '0'}
          onChange={handleDashChange}
          className={styles.toolbarSelect}
        >
          <option value="0">Solid</option>
          <option value="5,5">Dashed</option>
          <option value="2,2">Dotted</option>
          <option value="10,5">Long Dash</option>
        </select>
      </div>
    </div>
  );
}
